import { QaCalibrationDisputeFilter, QaCalibrationDisputeStatus } from '@/gql/graphql';
import util from '@/Utils/util';
import type { ListType } from '@/models/app';
import type { QaCalibrationRow } from '@/services/qaCalibration/fetchQaCalibrations';

export const MAX_TEXT_LENGTH = 5000;

export const DISPUTE_FILTER_OPTIONS: ListType[] = [
  { id: 1, key: QaCalibrationDisputeFilter.None, label: 'No dispute' },
  { id: 2, key: QaCalibrationDisputeFilter.Open, label: 'Open dispute' },
  { id: 3, key: QaCalibrationDisputeFilter.Resolved, label: 'Settled dispute' },
];

const DISPUTE_STATUS_LABELS: Readonly<Record<QaCalibrationDisputeStatus, string>> = {
  [QaCalibrationDisputeStatus.Open]: 'Open',
  [QaCalibrationDisputeStatus.Resolved]: 'Settled',
};

export const disputeLabel = (row: QaCalibrationRow): string => (row.dispute ? DISPUTE_STATUS_LABELS[row.dispute.status] : 'None');

export const yesNoLabel = (value?: boolean | null): string => (value == null ? '' : util.convertBooleanToYesNo(value));
